import { Button, Form, Input, Modal, Row } from 'antd';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import accessKeysApi from '../../../../api/aws-access-keys';
import openNotification from '../../../../components/Toastr';
import * as Actions from '../../../../redux/session/action';

const { Item } = Form;
function WoocommerceSellerAccount({ tab, session }) {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [loadingIsValidAccount, setLoadingIsValidAccount] = useState(false);

  const saveCredentials = (credentials) => {
    setLoadingIsValidAccount(true);
    accessKeysApi
      .saveCredentials(
        session?.userInfo?.commercial_partner_id[0],
        tab,
        credentials
      )
      .then(() => {
        Modal.success({
          content: 'Se asoció la cuenta exitosamente',
        });
        form.resetFields();
        setLoadingIsValidAccount(false);
        dispatch(Actions.updateSellerAccountStatusSession(true));
      })
      .catch(() => {
        setLoadingIsValidAccount(false);
        openNotification({
          status: false,
          content: 'No se pudo validar la cuenta',
        });
      });
  };

  return (
    <Form name={`${tab}-form`} form={form} onFinish={saveCredentials}>
      <Row>
        <span
          style={{
            fontSize: '18px',
            marginBottom: 10,
            marginTop: 15,
            width: '100%',
          }}
        >
          Site URL
        </span>
      </Row>
      <Row>
        <Item
          name="url"
          rules={[
            {
              required: true,
              message: 'Por favor ingresar la url de su tienda',
            },
          ]}
          style={{
            width: '100%',
            borderRadius: '10px',
          }}
        >
          <Input
            placeholder="https://lapwoocommerce.cl"
            className="newModalConnectInput"
          />
        </Item>
      </Row>

      <Row>
        <span
          style={{
            fontSize: '18px',
            marginBottom: 10,
            marginTop: 15,
            width: '100%',
          }}
        >
          Consumer Key
        </span>
      </Row>
      <Row>
        <Item
          name="consumerKey"
          rules={[
            {
              required: true,
              message: 'Por favor ingresar el consumer key',
            },
          ]}
          style={{
            width: '100%',
            borderRadius: '10px',
          }}
        >
          <Input
            placeholder="ck_762na5mm3mm1bb8qpuv491njl5tr79veu7u9sv97"
            className="newModalConnectInput"
          />
        </Item>
      </Row>

      <Row>
        <span
          style={{
            fontSize: '18px',
            marginBottom: 10,
            marginTop: 15,
            width: '100%',
          }}
        >
          Consumer Secret
        </span>
      </Row>
      <Row>
        <Item
          name="consumerSecret"
          rules={[
            {
              required: true,
              message: 'Por favor ingresar el consumer secret',
            },
          ]}
          style={{
            width: '100%',
            borderRadius: '10px',
          }}
        >
          <Input
            placeholder="cs_b2ktm9039x0smmokbo2yuunbrb7e0fsc5gei35gq"
            className="newModalConnectInput"
          />
        </Item>
      </Row>

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Button
          type="primary"
          style={{
            marginTop: 40,
            marginBottom: 15,
            padding: '5px 20px',
            height: '40px',
          }}
          onClick={() => form.submit()}
          loading={loadingIsValidAccount}
          disabled={loadingIsValidAccount}
        >
          Conectar marketplace
        </Button>
      </div>
    </Form>
  );
}

WoocommerceSellerAccount.propTypes = {
  tab: PropTypes.string.isRequired,
  session: PropTypes.instanceOf(Object).isRequired,
};

export default WoocommerceSellerAccount;
